// src/stage1/Life Meters/FoodTank.jsx
import React, { useMemo } from 'react';

export default function FoodTank({ value = 0, total = 5 }) {
  // clamp and normalize
  const clamped = Math.max(0, Math.min(total, value));
  const pct = (clamped / total) * 100;

  // optional tick labels 0..total (we'll hide visually except at E/F)
  const ticks = useMemo(() => Array.from({ length: total + 1 }, (_, i) => i), [total]);

  return (
    <div className="tank-row" aria-label={`Tank ${clamped} of ${total}`}>

      <div className="tank">
        <div className="tank-fill" style={{ width: `${pct}%` }} />
        {/* tick marks */}
        {ticks.map((t) => (
          <span
            key={t}
            className="tank-tick"
            style={{ left: `${(t / total) * 100}%` }}
          />
        ))}
      </div>

    </div>
  );
}
